export default {
  MEDIA_CORNERS_GIF: './images/website-design/media-corners.gif',
  COLUMN_CORNERS_GIF: './images/website-design/column-corners.gif',
};
